import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Homepage copy managed from the admin CMS. Returns `null` until loaded so
 * callers fall back to their own defaults and nothing flashes empty.
 */
export default function useSiteContent() {
  const [content, setContent] = useState(null);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [c, b] = await Promise.all([
          axios.get(`${API}/content/homepage`),
          axios.get(`${API}/content/banners`),
        ]);
        if (!active) return;
        setContent(c.data.content || {});
        setBanners(b.data.banners || []);
      } catch (err) {
        if (active) setContent({});
      }
    })();
    return () => { active = false; };
  }, []);

  // t('key', 'fallback') — CMS value if the admin set one, else the fallback.
  const t = (key, fallback) => (content && content[key]) || fallback;

  return { content, banners, t };
}
